(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('NeighbourhoodCanvasService', NeighbourhoodCanvasService);

    NeighbourhoodCanvasService.$inject = ['$resource','restService','$q','$rootScope'];
    
    function NeighbourhoodCanvasService ($resource,restService,$q,$rootScope) {
    	
    }
})();